import { type ChangeEvent, useEffect, useState } from 'react'
import { useDebounce } from '@/hooks/ui/use-debounce'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'
import { ReviewCard } from '../review-card'

interface StudentObervationCardProps {
  description: string
  formMethods: StudentRequestedCoursesFormMethods
}

export const StudentObervationCard = ({
  description,
  formMethods
}: StudentObervationCardProps) => {
  const [localValue, setLocalValue] = useState('')
  const debouncedValue = useDebounce(localValue, 500)

  const handleValue = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setLocalValue(event.target.value.trimStart())
  }

  useEffect(() => {
    formMethods?.setValue?.('observation', debouncedValue, {
      shouldDirty: false,
      shouldValidate: false
    })
  }, [debouncedValue])

  return (
    <ReviewCard title="Observações para o aluno">
      <div className="p-6">
        <p className="text-foreground/80">{description}</p>
        <div className="min-h-64 border border-ring/50 rounded-lg mt-5 flex">
          <textarea
            onChange={handleValue}
            value={localValue}
            placeholder="Digite aqui"
            className="w-full border-none flex-grow p-4 resize-none outline-none"
          ></textarea>
        </div>
      </div>
    </ReviewCard>
  )
}
